import React from 'react';
import Logo from '../../atoms/Logo';

const Header = () => (
  <div>
    <Logo />
    <a className="logout font-lato" href="http://www.bestwaywholesale.co.uk/logout">Logout</a>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// src/components/molecules/Header/index.jsx